<template>
  <div>
    <transition name="slide-fade">
      <div v-if="pictures.length">
        <div class="v-collective-grid">
          <div class="v-collective-grid-column" v-for="column of columns" :key="column">
            <div class="grid-item grid-item-_" v-for="(picture, index) of pluckedImagesFromColumn(column)" :key="picture.picId" v-bind:class="calculateImageClass(index)">
              <img :src="picture.url"/>
              <div class="v-collective-grid-footer"><b>{{picture.name}}</b></div>
            </div>
          </div>
        </div>
      </div>
      <p v-if="!pictures.length && !loading" style="font-size: 14px; opacity: 0.6;">Looks like this user hasn't uploaded any pictures yet.</p>
    </transition>
    <div class="v-loading-dots" v-if="loading">
      <i class="v-loading-dot"></i>
      <i class="v-loading-dot"></i>
      <i class="v-loading-dot"></i>
    </div>
    <div v-infinite-scroll="fetchImageWrapper" infinite-scroll-disabled="loading || !pictures.length" infinite-scroll-distance="50"></div>
  </div>
</template>

<style lang="scss">
.v-collective-grid {
  position: relative;
  max-width: 1080px;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;

  .v-collective-grid-column {
    display: inline-flex;
    margin: 0 5px;
    width: 30%;
    flex-direction: column;
    align-items: flex-start;
    vertical-align: top;
  }

  &:after {
    display: block;
    content: '';
    clear: both;
  }
}

.grid-item, .grid-column-size {
  width: 100%;
  margin: 0 5px;
}

.grid-item {
  box-sizing: border-box;
  display: inline-block;
  cursor: zoom-in;
  transition: box-shadow 250ms ease;
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
  height: auto;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility:    hidden;
  -ms-backface-visibility:     hidden;
  -webkit-perspective: 1000;

  img {
    display: block;
    max-width: 100%;
  }

  .v-collective-grid-footer {
    background: linear-gradient(to bottom, transparent, black);
    position: absolute;
    bottom: -10px;
    left: 0;
    text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 14px;
    padding: 8px 12px;
    opacity: 0;
    transition: 150ms ease;
    box-sizing: border-box;
    text-align: left;
    width: 100%;
  }

  &:hover {
    transition: 250ms ease;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.2);
    z-index: 1000;

    & .v-collective-grid-footer {
      bottom: 0;
      opacity: 1;
      transition: 150ms ease;
    }
  }
}

</style>

<script>

export default {
  props: ['collective'],
  data: function () {
    return {
      collectivePictures: this.collective.images,
      pictures: [],
      loading: true,
      pageIndex: 1,
      itemsPerPage: 10,
      columns: 3
    }
  },
  methods: {
    calculateImageClass: function (index) {
      let classObj = {}
      classObj['grid-item-_' + (Math.floor(index / this.itemsPerPage) + 1)] = true
      return classObj
    },
    fetchImageWrapper: function () {
      if (this.loading) return false
      this.fetchNewImages(this.pageIndex + 1).then(() => {
        this.pageIndex ++
      })
    },
    pluckedImagesFromColumn: function (columnIndex) {
      if (!this.collective.images || this.collective.images.length === 0) return []
      return this.pictures.filter((val, imgIndex) => (imgIndex % this.columns) === (columnIndex % this.columns))
    },
    fetchNewImages: function (currentPage) {
      if (!this.collective.images || this.collective.images.length === 0) {
        this.loading = false
        return Promise.resolve(false)
      }

      this.loading = true
      let images = Object.keys(this.collective.images)

      return Promise.all(images.slice((currentPage - 1) * this.itemsPerPage, this.itemsPerPage + (currentPage - 1) * this.itemsPerPage).map((picture) => {
        // Find download URLs for each.
        return this.$firestore.collection('images').doc('@' + this.collective.handle)
          .collection(picture.split('@')[0]).doc(picture.split('@')[1])
          .get()
          .then((pictureDoc) => {
            if (!pictureDoc.exists) return false
            return this.$firebase.storage()
              .refFromURL(`gs://encadyma-prism-dev.appspot.com/${pictureDoc.data().fullpath}`)
              .getDownloadURL()
              .then(url => ({ picId: picture, url: url, ...pictureDoc.data() }))
          })
          .catch(err => err)
      })).then((newImages) => {
        this.loading = false
        this.pictures = this.pictures.concat(newImages.filter(image => !!image).sort((a, b) => b.timestamp - a.timestamp))
      })
    }
  },
  mounted: function () {
    if (!this.collective.images) {
      this.loading = false
      return false
    }

    this.fetchNewImages(this.pageIndex)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Components/Gallery.vue